// Velo API Reference: https://www.wix.com/velo/reference/api-overview/introduction

import wixLocation from 'wix-location';
import { local } from 'wix-storage';

$w.onReady(function () {

    let myValue = local.getItem("myState");

    if (myValue === "S5") {
        local.setItem("myState", "null")
        $w("#statebox8").changeState("S5");
        }
    if (myValue === "S6") {
        local.setItem("myState", "null")
        $w("#statebox8").changeState("S6");
        }


    //stage00

    // $w("#button111").onClick((event) => {
    //     $w("#slideshow1").changeSlide(1);
    // });


    //stage1
    $w("#goto1x1").onClick((event) => {
        $w("#statebox8").changeState("S1");
    });

    $w("#goto2x1").onClick((event) => {
        $w("#statebox8").changeState("S2");
    });

    $w("#goto3x1").onClick((event) => {
        $w("#statebox8").changeState("S3");
    });

    $w("#goto4x1").onClick((event) => {
        $w("#statebox8").changeState("S4");
    });

    $w("#goto5x1").onClick((event) => {
        $w("#statebox8").changeState("S5");

    });
    
    $w("#goto6x1").onClick((event) => {
        $w("#statebox8").changeState("S6");

    });
    

    //stage2
    $w("#goto1x2").onClick((event) => {
        $w("#statebox8").changeState("S1");
    });

    $w("#goto2x2").onClick((event) => {
        $w("#statebox8").changeState("S2");
    });

    $w("#goto3x2").onClick((event) => {
        $w("#statebox8").changeState("S3");
    });

    $w("#goto4x2").onClick((event) => {
        $w("#statebox8").changeState("S4");
    });

    $w("#goto5x2").onClick((event) => {
        $w("#statebox8").changeState("S5");

    });

    $w("#goto6x2").onClick((event) => {
        $w("#statebox8").changeState("S6");

    });

    //stage3
    $w("#goto1x3").onClick((event) => {
        $w("#statebox8").changeState("S1");
    });

    $w("#goto2x3").onClick((event) => {
        $w("#statebox8").changeState("S2");
    });

    $w("#goto3x3").onClick((event) => {
        $w("#statebox8").changeState("S3");
    });

    $w("#goto4x3").onClick((event) => {
        $w("#statebox8").changeState("S4");
    });

    $w("#goto5x3").onClick((event) => {
        $w("#statebox8").changeState("S5");

    });

    $w("#goto6x3").onClick((event) => {
        $w("#statebox8").changeState("S6");

    });

    //stage4
    $w("#goto1x4").onClick((event) => {
        $w("#statebox8").changeState("S1");
    });

    $w("#goto2x4").onClick((event) => {
        $w("#statebox8").changeState("S2");
    });

    $w("#goto3x4").onClick((event) => {
        $w("#statebox8").changeState("S3");
    });

    $w("#goto4x4").onClick((event) => {
        $w("#statebox8").changeState("S4");
    });

    $w("#goto5x4").onClick((event) => {
        $w("#statebox8").changeState("S5");

    });

    $w("#goto6x4").onClick((event) => {
        $w("#statebox8").changeState("S6");

    });

    //stage5
    $w("#goto1x5").onClick((event) => {
        $w("#statebox8").changeState("S1");
    });

    $w("#goto2x5").onClick((event) => {
        $w("#statebox8").changeState("S2");
    });

    $w("#goto3x5").onClick((event) => {
        $w("#statebox8").changeState("S3");
    });

    $w("#goto4x5").onClick((event) => {
        $w("#statebox8").changeState("S4");
    });

    $w("#goto5x5").onClick((event) => {
        $w("#statebox8").changeState("S5");
    });

    $w("#goto6x5").onClick((event) => {
        $w("#statebox8").changeState("S6");

    });

    //stage6
    $w("#goto1x6").onClick((event) => {
        $w("#statebox8").changeState("S1");
    });

    $w("#goto2x6").onClick((event) => {
        $w("#statebox8").changeState("S2");
    });

    $w("#goto3x6").onClick((event) => {
        $w("#statebox8").changeState("S3");
    });

    $w("#goto4x6").onClick((event) => {
        $w("#statebox8").changeState("S4");
    });

    $w("#goto5x6").onClick((event) => {
        $w("#statebox8").changeState("S5");
    });

    $w("#goto6x6").onClick((event) => {
        $w("#statebox8").changeState("S6");

    });

});